import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";

interface InfoWithLabelSkeletonProps {
  contentWidth?: string;
  contentHeight?: string;
  fullWidth?: boolean;
  className?: string;
}

export const InfoWithLabelSkeleton = ({
  contentWidth = "w-24",
  contentHeight = "h-7",
  fullWidth = true,
  className,
}: InfoWithLabelSkeletonProps) => (
  <Stack
    align="start"
    gap={2}
    className={cn(className, { "w-full": fullWidth })}
  >
    {/* Label skeleton - matches subtitleW3 (text-sm font-semibold) height */}
    <Skeleton className="h-5 w-16" />
    {/* Content skeleton - matches bodyW1 (text-sm font-normal) height by default */}
    <Skeleton className={`${contentHeight} ${contentWidth}`} />
  </Stack>
);
